var map = {
	".": 4,
	"./": 4,
	"./api": 118,
	"./api/": 118,
	"./api/api": 196,
	"./api/api.js": 196,
	"./api/index": 118,
	"./api/index.js": 118,
	"./index": 4,
	"./index.js": 4,
	"./platform": 79,
	"./platform/": 79,
	"./platform/PhiPhiTours": 197,
	"./platform/PhiPhiTours/": 197,
	"./platform/PhiPhiTours/index": 197,
	"./platform/PhiPhiTours/index.js": 197,
	"./platform/TravisGo": 198,
	"./platform/TravisGo/": 198,
	"./platform/TravisGo/index": 198,
	"./platform/TravisGo/index.js": 198,
	"./platform/index": 79,
	"./platform/index.js": 79
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;